import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetGroupListUseCaseInterface } from 'domain/usecases';

export class RemoteGroupList implements GetGroupListUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetGroupListUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetGroupListUseCaseInterface.Params,
  ): Promise<GetGroupListUseCaseInterface.Result> {
    const { page, length } = params;
    const urlParsed = `${this.url}/${page}/${length}`;
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(urlParsed, {
        entity: params.entity,
        course: params.course,
        semester: params.semester,
        curricularUnit: params.curricularUnit,
        order: params.order,
        orderColumn: params.orderColumn,
        query: params.query,
      }),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
